<a [class]="linkClasses" [href]="href" [target]="target">
  <ng-content></ng-content>
</a>
